// Helper partagé client + serveur pour produire le nom d'affichage d'un
// prospect, qu'il soit une entreprise (`type='company'`) ou un particulier
// (`type='individual'`). Les champs pertinents sont garantis non-null pour
// le type concerné par le CHECK SQL `prospects_type_consistency_chk`.

export type ProspectDisplayFields = {
  type: 'company' | 'individual';
  companyName?: string | null;
  firstName?: string | null;
  lastName?: string | null;
};

export function displayName(p: ProspectDisplayFields): string {
  if (p.type === 'individual') {
    const full = `${p.firstName ?? ''} ${p.lastName ?? ''}`.trim();
    return full === '' ? '(sans nom)' : full;
  }
  return p.companyName ?? '(sans nom)';
}
